import throttle from 'lodash/throttle';

const defaultOptions = {
    startHorCss: 'can-scroll-left',
    endHorCss: 'can-scroll-right',
    startVertCss: 'can-scroll-top',
    endVertCss: 'can-scroll-bottom'
};

class Scrollable {
    constructor(root, scrollNode, options = defaultOptions) {
        this.root = root;
        this.scrollNode = scrollNode;
        this.options = Object.assign({}, defaultOptions, options);

        if (!this.root) throw new Error('You have to provide "root" node');
        if (!this.scrollNode) throw new Error('You have to provide "scroll" node');

        this.state = {
            hasStartHorCss: false,
            hasendHorCss: false,
            startVertCss: false,
            endVertCss: false,
        };

        this.init();
    }

    init() {
        this.onScroll = throttle(this.update, 50);
        this.scrollNode.addEventListener('scroll', this.onScroll);
        this.update();
    }

    update = () => {
        const scrollLeft = this.scrollNode.scrollLeft;
        const scrollWidth = this.scrollNode.scrollWidth;
        const offsetWidth = this.scrollNode.offsetWidth;

        if (scrollLeft > 0) {
            if (!this.state.hasStartHorCss) {
                this.root.classList.add(this.options.startHorCss);
                this.state.hasStartHorCss = true;
            }
        } else if (this.state.hasStartHorCss) {
            this.root.classList.remove(this.options.startHorCss);
            this.state.hasStartHorCss = false;
        }

        if (scrollLeft + offsetWidth !== scrollWidth) {
            if (!this.state.endHorCss) {
                this.root.classList.add(this.options.endHorCss);
                this.state.endHorCss = true;
            }
        } else if (this.state.endHorCss) {
            this.root.classList.remove(this.options.endHorCss);
            this.state.endHorCss = false;
        }

        if (scrollLeft + offsetWidth !== scrollWidth) {
            if (!this.state.endHorCss) {
                this.root.classList.add(this.options.endHorCss);
                this.state.endHorCss = true;
            }
        } else if (this.state.endHorCss) {
            this.root.classList.remove(this.options.endHorCss);
            this.state.endHorCss = false;
        }
    }

    destroy() {
        this.root.classList.remove(this.options.startHorCss);
        this.root.classList.remove(this.options.endHorCss);
        this.scrollNode.removeEventListener('scroll', this.onScroll);
    }
}

export default Scrollable;
